import { fetchEndpoint } from "../network";

export default {
  /* 问卷管理 */
  // 问卷列表
  list(params) {
    return fetchEndpoint("/questionnaire/list", "GET", params);
  },
  //新建问卷
  add(params) {
    return fetchEndpoint("/questionnaire/add", "POST", params);
  },
  // 删除问卷
  remove(params) {
    return fetchEndpoint("/questionnaire/delete", "POST", params);
  },
  //回收站删除问卷
  removeRecycle(params) {
    return fetchEndpoint("/questionnaire/recycle/delete", "POST", params);
  },
  //回收站问卷撤回
  recycleWithdraw(params) {
    return fetchEndpoint("/questionnaire/recycle/withdraw", "POST", params);
  },
  //回收站问卷清空所有
  recycleQACleanAll() {
    return fetchEndpoint("/questionnaire/recycle/clean", "POST");
  },

  // 问卷详情
  detail(params) {
    return fetchEndpoint("/questionnaire/detail", "GET", params);
  },
  //修改问卷基础信息
  base(params) {
    return fetchEndpoint("/questionnaire/modify/base", "POST", params);
  },
  //成绩列表(可调试)
  historyList(params) {
    return fetchEndpoint("/questionnaire/history/list", "GET", params);
  },
  //导出成绩列表
  historyListExport(params) {
    return fetchEndpoint("/questionnaire/history/export", "GET", params);
  },
  //成绩详情
  historyDetail(params) {
    return fetchEndpoint("/questionnaire/history/detail", "GET", params);
  },
  //修改问卷
  modify(params) {
    return fetchEndpoint("/questionnaire/modify", "POST", params);
  },
  //题目列表
  relationList(params) {
    return fetchEndpoint(
      "/questionnaire/question/relation/list",
      "GET",
      params
    );
  },
  //问卷添加关联题目
  relationAdd(params) {
    return fetchEndpoint(
      "/questionnaire/question/relation/add",
      "post",
      params
    );
  },
  //问卷删除关联题目
  relationDelete(params) {
    return fetchEndpoint(
      "/questionnaire/question/relation/delete",
      "post",
      params
    );
  },
  //问卷关联题目修改排序
  relationSort(params) {
    return fetchEndpoint(
      "/questionnaire/question/relation/modify",
      "post",
      params
    );
  },
  //导入题库
  questionImport(file) {
    return fetchEndpoint("/questionnaire/question/import", "POST", {
      file: file,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  /* 题库管理 */
  //题库列表
  questionList(params) {
    return fetchEndpoint("/questionnaire/question/list", "GET", params);
  },
  //修改题库问题基础信息(可调试)
  questionBase(params) {
    return fetchEndpoint("/questionnaire/question/modify/base", "POST", params);
  },
  //修改题库问题(可调试)
  questionModify(params) {
    return fetchEndpoint("/questionnaire/question/modify", "POST", params);
  },
  //删除问题(可调试)
  questionDelete(params) {
    return fetchEndpoint("/questionnaire/question/delete", "POST", params);
  },
  //删除回收站问题(可调试)
  questionRecycleDelete(params) {
    return fetchEndpoint(
      "/questionnaire/question/recycle/delete",
      "POST",
      params
    );
  },
  //回收站问题撤回(可调试)
  questionBlankWithdraw(params) {
    return fetchEndpoint(
      "/questionnaire/question/recycle/withdraw",
      "POST",
      params
    );
  },
  //回收站问题清空所有
  questionBlankCleanAll() {
    return fetchEndpoint("/questionnaire/question/recycle/clean", "POST");
  },

  //添加题库问题(可调试)
  questionAdd(params) {
    return fetchEndpoint("/questionnaire/question/add", "POST", params);
  },
  //问题详情(可调试)
  questionDetail(params) {
    return fetchEndpoint("/questionnaire/question/detail", "GET", params);
  },
  /* 分值管理 */
  //分值列表
  scoreList(params) {
    return fetchEndpoint("/questionnaire/score/list", "GET", params);
  },
  //修改分值
  scoreModify(params) {
    return fetchEndpoint("/questionnaire/score/modify", "POST", params);
  },

  // merchantList(params) {
  //   return fetchEndpoint("/qa/list/merchant", "GET", params);
  // },
  // // 添加热议
  // create(params) {
  //   return fetchEndpoint("/qa/add", "POST", params);
  // },

  // // 修改热议
  // edit(params) {
  //   return fetchEndpoint("/qa/update", "POST", params);
  // },

  // // 删除商家问题
  // removeMerchant(params) {
  //   return fetchEndpoint("/qa/delete/merchant", "GET", params);
  // },

  // // 提交审核
  // examination(params) {
  //   return fetchEndpoint("/qa/examination", "GET", params);
  // },
  // // 审核
  // revocation(params) {
  //   return fetchEndpoint("/qa/revoke", "GET", params);
  // },
  // show(params) {
  //   return fetchEndpoint("/qa/show", "GET", params);
  // },
  // hidden(params) {
  //   return fetchEndpoint("/qa/hidden", "GET", params);
  // },
  // contentOperationInfo(params) {
  //   return new Promise((resolve, reject) => {
  //     fetchEndpoint("/contentOperation/contentOperationInfo", "GET", params)
  //       .then((e) => {
  //         if (e.code == 0) {
  //           const obj = {
  //             isCSP: "晨视频报",
  //             isContentCarousel: "轮播位",
  //             isFloat: "浮标",
  //             isSplash: "闪屏",
  //             isSubject: "推荐位",
  //             isVideoCollection: "合集",
  //           };
  //           let strArr = [];
  //           for (const key in obj) {
  //             if (e.data.hasOwnProperty(key)) {
  //               const arr = [];
  //               for (const iterator of e.data[key]) {
  //                 if (iterator.type == params.type) {
  //                   arr.push(iterator.contentIndexId);
  //                 }
  //               }
  //               if (arr.length > 0) {
  //                 strArr.push(`${obj[key]}ID:${arr.join(",")}`);
  //               }
  //             }
  //           }
  //           resolve(strArr.join("/"));
  //         } else {
  //           reject(`CODE:${e.code},MSG:${e.msg}`);
  //         }
  //       })
  //       .catch((err) => {
  //         reject(err);
  //       });
  //   });
  // },
};
